import { Link } from '@inertiajs/react';

import { useIsPageEditor } from '@/hooks/use-is-page-editor';
import { useIsPreviewMode } from '@/hooks/use-is-preview-mode';
import type { CollectionItem } from '@/lib/blocks/collection/blocks';
import { readString } from '@/lib/prop-utils';
import { cn, normalizeRootRelativePath } from '@/lib/utils';

function indexCollectionCardHref(item: CollectionItem): string | undefined {
  const path = readString(item.path)?.trim();
  return path ? normalizeRootRelativePath(path) : undefined;
}

export function IndexCollectionCardLink({
  item,
  enabled,
}: {
  item: CollectionItem;
  enabled: boolean;
}) {
  const isPageEditor = useIsPageEditor();
  const isPreview = useIsPreviewMode();
  const href = indexCollectionCardHref(item);
  if (!enabled || !href) return null;

  const disableNavigation = isPageEditor && !isPreview;
  const title = readString(item.title)?.trim();

  return (
    <Link
      href={href}
      aria-label={title ? `View ${title}` : 'View item'}
      aria-hidden={disableNavigation ? true : undefined}
      tabIndex={disableNavigation ? -1 : undefined}
      className={cn(
        'absolute inset-0 z-20 rounded-[inherit]',
        disableNavigation && 'pointer-events-none',
      )}
      onClick={(event) => {
        if (disableNavigation) event.preventDefault();
      }}
    />
  );
}
